import { Link } from '@swp/link-provider';
var LINK_REGEXP = /^(https:|http:|mailto:|tel:|\/\/)/;
export default function linkify(_ref) {
  var _ref$href = _ref.href,
      href = _ref$href === void 0 ? '#' : _ref$href,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? '_blank' : _ref$target;

  if (href[0] === '#') {
    return {
      Component: 'a',
      props: {
        href: href
      }
    };
  }

  if (href[0] === '/' && href[1] !== '/') {
    return {
      Component: Link,
      props: {
        to: href
      }
    };
  }

  if (!LINK_REGEXP.test(href)) {
    href = '//' + href;
  }

  return {
    Component: 'a',
    props: {
      href: href,
      target: target
    }
  };
}